import { render, staticRenderFns } from "./CurriculumType.vue?vue&type=template&id=8717b524&scoped=true&"
import script from "./CurriculumType.vue?vue&type=script&lang=js&"
export * from "./CurriculumType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8717b524",
  null
  
)

export default component.exports